import React from 'react';
import {
  SkeletonThumbnail,
  SkeletonDisplayText,
  SkeletonBodyText,
  Layout,
  Card,
} from '@shopify/polaris';
import styleConstants from 'src/styles/constants';

const CourseCardSkeleton = () => (
  <Layout.Section className="cards" oneThird>
    <Card>
      <div className="course-card__image">
        <SkeletonThumbnail />
      </div>
      <div className="course-card-skeleton__body">
        <SkeletonBodyText />
        <br />
        <SkeletonDisplayText size="small" />
      </div>
      <div className="course-card-skeleton__footer">
        <SkeletonDisplayText size="small" />
      </div>
    </Card>

    <style jsx>{`
      .course-card__image :global(.Polaris-SkeletonThumbnail) {
        width: 100%;
        height: 150px;
      }

      .course-card-skeleton__body {
        padding: ${styleConstants.spacing.five} ${styleConstants.spacing.five}
          ${styleConstants.spacing.four};
      }

      .course-card-skeleton__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        background-color: ${styleConstants.color.lightGrey};
        padding: 0 ${styleConstants.spacing.five};
      }

      .course-card-skeleton__footer
        :global(.Polaris-SkeletonDisplayText--sizeSmall) {
        flex: 1 1 100%;
        max-width: 30%;
      }
    `}</style>
  </Layout.Section>
);

const ProductGridLoadingState = () => (
  <Layout>
    {[...Array(6)].map((e, i) => {
      return <CourseCardSkeleton key={i} />; // eslint-disable-line react/no-array-index-key
    })}
  </Layout>
);

export default ProductGridLoadingState;
export { CourseCardSkeleton, ProductGridLoadingState };
